
export default "/assets/arrow-top-right-on-square-micro.988228aa.svg"